import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { REVIEWS } from "@/data/products";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reviews() {
  const [customerReviews, setCustomerReviews] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((r) => setCustomerReviews(r.data))
      .catch(() => setCustomerReviews([]));
  }, []);

  const all = [
    ...customerReviews.map((r) => ({ ...r, key: r.id, verified: true })),
    ...REVIEWS.map((r) => ({ ...r, key: r.name, verified: false })),
  ];

  return (
    <section id="word-of-mouth" data-testid="reviews-section" className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32 scroll-mt-20">
      <Reveal>
        <p className="overline-label">Word of Mouth</p>
        <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">Worn. Noticed. Reviewed.</h2>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-2 gap-px bg-black/10 border border-black/10">
        {all.map((r, i) => (
          <Reveal key={r.key} delay={i * 0.08} className="bg-[#F7F3EE] p-8 md:p-12">
            <div className="flex items-center justify-between">
              <div className="flex gap-1 text-[#BA8D53]">
                {Array.from({ length: r.rating }).map((_, s) => (
                  <Star key={`${r.key}-star-${s}`} size={14} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              {r.verified && (
                <span data-testid={`verified-badge-${r.key}`} className="text-[0.56rem] uppercase tracking-[0.2em] text-[#BA8D53] border border-[#BA8D53]/40 px-2 py-0.5">
                  Verified Buyer
                </span>
              )}
            </div>
            <p className="mt-6 font-serif-brand text-xl md:text-2xl font-light leading-relaxed italic">
              “{r.text}”
            </p>
            <p className="mt-6 text-[0.68rem] uppercase tracking-[0.26em] text-black/50">
              {r.name} — {r.city}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
